import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloudIcon from '../assets/images/cloud-icon.svg';
import { useAuth } from '../hooks/useAuth';
import { getAllElements } from '../services/getAllElements';
import { useRecoilState } from 'recoil';
import { allElementsState } from '../states/atoms';
import { io } from 'socket.io-client';
import QRCode from 'react-qr-code';
import { FirebaseBrain } from '../services/FirebaseBrain/FirebaseBrain';

const QrModal = ({ onClick }) => {
  const { t } = useTranslation();
  const [socket, setSocket] = useState(null);
  const { isAuthenticated, setIsAuthenticated, setAuthCookie, getAuthCookie } = useAuth();
  const [, setAllElementsData] = useRecoilState(allElementsState);

  const [qrValue, setQrValue] = useState('');

  const getAllElementsData = async (token) => {
    const allElements = await getAllElements(token);
    setAllElementsData(allElements);
  };

  useEffect(() => {
    if (!isAuthenticated) {
      const wsHost = process.env.REACT_APP_WS_HOST;

      if (!wsHost) {
        // Опционально логируем ошибку конфигурации, если хоста нет
        FirebaseBrain.qrModalConnectionError();
        return;
      }

      const newSocket = io(wsHost);
      setSocket(newSocket);

      // Можно добавить слушатель ошибок сокета для полноты данных
      newSocket.on('connect_error', () => {
        FirebaseBrain.qrModalConnectionError();
      });

      newSocket.on('number', (data) => {
        if (data && !data.statusSuccess) {
          setQrValue(`pt-pro://${data.client_Id}-${data.qr_code}`);
        }

        if (data.statusSuccess) {
          setAuthCookie(data.qr_code);
          setIsAuthenticated(true);

          // ТРИГГЕР: Пользователь успешно подтвердил PRO-статус через мобилку
          FirebaseBrain.qrModalAuthSuccess();

          newSocket.off('number');
        }
      });

      return () => {
        newSocket.off('number');
        newSocket.disconnect();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseClick = () => {
    if (socket) {
      socket.disconnect();
    }

    // ТРИГГЕР: Логируем закрытие окна и передаем текущий статус подписки
    FirebaseBrain.qrModalClosed(isAuthenticated);

    getAllElementsData(getAuthCookie());
    onClick();
  };

  // ... остальной рендер компонента (без изменений) ...
  return (
    <section className='qr-modal'>
      <div className='properties__background' onClick={handleCloseClick} />
      <div className='qr-modal__modal'>
        <div className='qr-modal__modal-wrapper'>
          <div className={`qr-modal__header ${isAuthenticated && 'qr-modal__header--success'}`}>
            {isAuthenticated ? (
              <>
                <div className='qr-modal__header-text'>
                  <h2 className='qr-modal__title'>
                    {t('string.translate.qr_modal2_title')}
                  </h2>
                  <p className='qr-modal__description'>
                    {t('string.translate.qr_modal2_subtitle')}
                  </p>
                </div>
                <div className='qr-modal__cloud-image'>
                  <img className='qr-modal__cloud' src={CloudIcon} alt='' />
                </div>
              </>
            ) : (
              <>
                <div className='qr-modal__header-text'>
                  <h2 className='qr-modal__title'>
                    {t('string.translate.qr_modal1_title')}
                  </h2>
                  <p className='qr-modal__description'>
                    {t('string.translate.qr_modal1_subtitle')}
                  </p>
                </div>

                <div className='qr-modal__qr-wrapper'>
                  {qrValue ? (
                    <div style={{
                      backgroundColor: 'white',
                      padding: '16px',
                      borderRadius: '16px',
                      width: 'fit-content',
                      margin: '0 auto'
                    }}>
                      <QRCode
                        value={qrValue}
                        size={160}
                        bgColor="#FFFFFF"
                        fgColor="#fc5811"
                        level="M"
                      />
                    </div>
                  ) : (
                    // Пустой блок фиксированного размера, чтобы верстка не "прыгала" при загрузке
                    <div style={{ width: 192, height: 192 }} />
                  )}
                </div>
              </>
            )}
          </div>

          <div className='qr-modal__content'>
            <ul className='qr-modal__list'>
              <li className='qr-modal__item'>
                <h3 className='qr-modal__item-title'>{t('string.translate.qr_modal_item1_1')}</h3>
                <p className='qr-modal__item-description'>{t('string.translate.qr_modal_item1_2')}</p>
              </li>
              <li className='qr-modal__item'>
                <h3 className='qr-modal__item-title'>{t('string.translate.qr_modal_item2_1')}</h3>
                <p className='qr-modal__item-description'>{t('string.translate.qr_modal_item2_2')}</p>
              </li>
              <li className='qr-modal__item'>
                <h3 className='qr-modal__item-title'>{t('string.translate.qr_modal_item3_1')}</h3>
                <p className='qr-modal__item-description'>{t('string.translate.qr_modal_item3_2')}</p>
              </li>
              <li className='qr-modal__item'>
                <p className='qr-modal__item-description'>{t('string.translate.qr_modal_message')}</p>
              </li>
            </ul>
          </div>
          <button
            className={`qr-modal__close-button ${isAuthenticated && 'qr-modal__close-button--success'}`}
            onClick={handleCloseClick}
          />
        </div>
      </div>
    </section>
  );
};

export default QrModal;